// Copyright (c) 2026 aiApas LLC. All Rights Reserved.
// GuardRok — Proprietary and Confidential. Patent Pending.
// Unauthorized use or distribution is prohibited.

export function GuardRokIcon({ size = 40 }: { size?: number }) {
  const w = size
  const h = Math.round(size * 84 / 72)
  return (
    <svg width={w} height={h} viewBox="0 0 72 84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M36 2L4 14V44C4 62 36 82 36 82C36 82 68 62 68 44V14L36 2Z" fill="#0f172a"/>
      <path d="M36 2L36 82" stroke="#1e293b" strokeWidth="1.5"/>
      <path d="M4 14L68 44" stroke="#1e293b" strokeWidth="1"/>
      <path d="M68 14L4 44" stroke="#1e293b" strokeWidth="1"/>
      <path d="M36 2L4 14L4 44L36 28Z" fill="#111827"/>
      <path d="M36 2L68 14L68 44L36 28Z" fill="#1a2535"/>
      <path d="M4 44L36 28L36 82C36 82 16 68 4 44Z" fill="#0d1520"/>
      <path d="M68 44L36 28L36 82C36 82 56 68 68 44Z" fill="#151f2e"/>
      <path d="M18 18L54 66" stroke="#E63946" strokeWidth="5" strokeLinecap="round"/>
      <path d="M36 4L6 15.5V44C6 61 36 80 36 80C36 80 66 61 66 44V15.5L36 4Z" fill="none" stroke="#E63946" strokeWidth="1.5" opacity="0.6"/>
    </svg>
  )
}

export default function GuardRokLogo({ size = 40 }: { size?: number }) {
  return <GuardRokIcon size={size} />
}
